








// @ is an alias to /src
import { Component, Vue } from 'vue-property-decorator'
import { AloCommande, getDefaultAloCommande } from '@/models/alo/AloCommande'

@Component({
  name: 'ReadAdresse',    
   props: {
    commande:{      
      default:getDefaultAloCommande()
    },
    loading:{
      type:Boolean,
      default:false
    }
  }
})
export default class ReadAdresse extends Vue {
  private commande!:AloCommande
  private loading!:boolean


  get configuration(){    
    return this.$store.myGetters.configuration
  }  
}
